"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVAILABLE_ROLES_GET_BY_ROLE_AND_PERMISSION = exports.AVAILABLE_ROLES_FETCH = exports.AVAILABLE_ROLES_SET = exports.AVAILABLE_ROLES_GET = exports.AVAILABLE_ROLES_GET_OR_FETCH = exports.AUTH_USER_EXPLORER_TOGGLE = exports.AUTH_USER_STATE_UPDATE = exports.AUTH_USER_UPDATE = exports.AUTH_USER_SET = exports.AUTH_USER_REFRESH = exports.AUTH_USER_GET = exports.AUTH_SET = void 0;
var api_1 = require("Modules/users/api");
var eventbus_1 = require("Public/store/modules/eventbus");
var parseUserGet_1 = require("Public/store/utils/parseUserGet");
var axios_1 = __importDefault(require("axios"));
exports.AUTH_SET = "auth/set";
exports.AUTH_USER_GET = "auth/user/get";
exports.AUTH_USER_REFRESH = "auth/user/refresh";
exports.AUTH_USER_SET = "auth/user/set";
exports.AUTH_USER_UPDATE = "auth/user/update";
exports.AUTH_USER_STATE_UPDATE = "auth/user/state/update";
exports.AUTH_USER_EXPLORER_TOGGLE = "auth/user/explorer/toggle";
exports.AVAILABLE_ROLES_GET_OR_FETCH = "availableRoles/get_or_fetch";
exports.AVAILABLE_ROLES_GET = "availableRoles/get";
exports.AVAILABLE_ROLES_SET = "availableRoles/set";
exports.AVAILABLE_ROLES_FETCH = "availableRoles/fetch";
exports.AVAILABLE_ROLES_GET_BY_ROLE_AND_PERMISSION = "availableRoles/get_by_role_and_permission";
var state = {
    user: null,
    availableRoles: [],
    availableRolesFetched: false,
};
var getters = (_a = {},
    _a[exports.AUTH_USER_GET] = function (_a) {
        var user = _a.user;
        return (0, parseUserGet_1.parseUserGet)(user);
    },
    _a);
var actions = (_b = {},
    _b[exports.AUTH_USER_REFRESH] = function (_a) {
        var commit = _a.commit;
        return axios_1.default
            .get("/api/init")
            .then(function (_a) {
            var data = _a.data;
            commit(exports.AUTH_USER_SET, data.user);
            eventbus_1.EventBus.$emit(eventbus_1.USER_AUTH_REFRESHED);
        })
            .catch(function (err) {
            console.log(err);
        });
    },
    _b[exports.AUTH_USER_UPDATE] = function (_a, data) {
        var commit = _a.commit, state = _a.state;
        if (!state.user)
            return;
        return axios_1.default.patch("/api/users/".concat(state.user.id), data).then(function (_a) {
            var data = _a.data;
            commit(exports.AUTH_USER_SET, data);
            eventbus_1.EventBus.$emit(eventbus_1.USER_AUTH_REFRESHED);
        });
    },
    _b[exports.AVAILABLE_ROLES_GET_OR_FETCH] = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var availableRoles;
        var _commit = _b._commit, state = _b.state, dispatch = _b.dispatch;
        return __generator(this, function (_c) {
            availableRoles = state.availableRoles;
            if (state.availableRolesFetched)
                return [2 /*return*/, Promise.resolve(availableRoles)];
            return [2 /*return*/, dispatch(exports.AVAILABLE_ROLES_FETCH)];
        });
    }); },
    _b[exports.AVAILABLE_ROLES_FETCH] = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var data;
        var commit = _b.commit, state = _b.state;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!state.user)
                        return [2 /*return*/, Promise.resolve(state.availableRoles)];
                    return [4 /*yield*/, axios_1.default
                            .get(api_1.endpoints.getUserAvailableRoles(state.user.id))
                            .then(function (res) { return res.data; })];
                case 1:
                    data = (_c.sent()).data;
                    commit(exports.AVAILABLE_ROLES_SET, data || []);
                    return [2 /*return*/, Promise.resolve(data)];
            }
        });
    }); },
    _b[exports.AVAILABLE_ROLES_GET_BY_ROLE_AND_PERMISSION] = function (_a, _b) { return __awaiter(void 0, [_a, _b], void 0, function (_c, _d) {
        var roles, desiredRoles;
        var dispatch = _c.dispatch;
        var role = _d.role, permission = _d.permission;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, dispatch(exports.AVAILABLE_ROLES_GET_OR_FETCH)];
                case 1:
                    roles = _e.sent();
                    desiredRoles = typeof role === "string" ? [role] : role;
                    if (!roles.length)
                        return [2 /*return*/, []];
                    return [2 /*return*/, roles.filter(function (userRole) {
                            var hasMainRole = desiredRoles.includes(userRole.name);
                            var isChildOfMainRole = !!userRole.parent_name && desiredRoles.includes(userRole.parent_name);
                            var hasRole = hasMainRole || isChildOfMainRole;
                            var hasRequiredPermission = !permission
                                ? true
                                : userRole.permissions.some(function (p) { return p.name === permission; });
                            return hasRole && hasRequiredPermission;
                        })];
            }
        });
    }); },
    _b);
var mutations = (_c = {},
    _c[exports.AUTH_SET] = function (state, _a) {
        var user = _a.user;
        if (!user)
            return;
        state.user = __assign({}, user);
    },
    _c[exports.AUTH_USER_SET] = function (state, user) {
        if (!user)
            return;
        state.user = __assign({}, user);
    },
    _c[exports.AUTH_USER_STATE_UPDATE] = function (state, payload) {
        state.user = __assign(__assign({}, state.user), payload);
    },
    _c[exports.AVAILABLE_ROLES_SET] = function (state, payload) {
        state.availableRoles = __spreadArray([], payload, true);
    },
    _c);
exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};
